// Collection H. — PDP variant reactive logic
// - Listens to Horizon's `variant:update` event
// - Toggles data-variant-available on the product info column
// - Re-renders ch-stock-delivery snippet from the section HTML
// - When variant is unavailable, shows a back-in-stock form (replaces ATC)
// - During variant transitions, briefly disables ATC to prevent race-condition 422s

(function () {
  'use strict';

  function findProductInfo() {
    return document.querySelector('.product-information, [data-product-info], product-information-component') || document.body;
  }

  function getAtcButton() {
    return document.querySelector('.product-form__submit, button[name="add"], .add-to-cart-button, [data-product-form] button[type="submit"]');
  }

  function setAvailability(available, variant) {
    var root = findProductInfo();
    root.setAttribute('data-variant-available', available ? 'true' : 'false');
    var btn = getAtcButton();
    if (btn) {
      if (!available) {
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      }
    }
    // Sticky ATC mobile : update text + disabled state
    var stickyBtn = document.querySelector('.ch-sticky-atc [data-sticky-atc-submit], .ch-sticky-atc button');
    if (stickyBtn) {
      if (available) {
        stickyBtn.removeAttribute('disabled');
        stickyBtn.textContent = 'Ajouter au panier';
      } else {
        stickyBtn.setAttribute('disabled', '');
        stickyBtn.textContent = 'Épuisé';
      }
    }
    renderBackInStockForm(available, variant);
  }

  function renderBackInStockForm(available, variant) {
    var holder = document.getElementById('ch-back-in-stock-holder');
    if (!holder) return;
    if (available) {
      holder.innerHTML = '';
      holder.style.display = 'none';
      return;
    }
    var productTitle = (document.querySelector('.product-title, h1[itemprop="name"], h1') || {}).textContent || '';
    var variantTitle = variant && variant.title ? variant.title : '';
    var subject = encodeURIComponent('Préviens-moi du retour : ' + productTitle.trim() + (variantTitle ? ' — taille ' + variantTitle : ''));
    var body = encodeURIComponent('Bonjour Hélène,\n\nJe souhaite être prévenue dès que ce produit revient en stock :\n\n' + productTitle.trim() + (variantTitle ? '\nTaille : ' + variantTitle : '') + '\n\nMerci !');
    holder.style.display = 'block';
    holder.innerHTML = [
      '<form class="ch-back-in-stock" method="POST" action="/contact" novalidate>',
      '  <input type="hidden" name="form_type" value="customer">',
      '  <input type="hidden" name="utf8" value="✓">',
      '  <input type="hidden" name="contact[tags]" value="back-in-stock">',
      '  <input type="hidden" name="contact[Body]" value="' + (productTitle.trim() + ' — taille ' + variantTitle).replace(/"/g, '&quot;') + '">',
      '  <p class="ch-back-in-stock__title"><strong>Plus dispo dans cette taille.</strong></p>',
      '  <label class="ch-back-in-stock__label" for="ch-bis-email">Préviens-moi du retour :</label>',
      '  <div class="ch-back-in-stock__row">',
      '    <input id="ch-bis-email" type="email" name="contact[email]" placeholder="ton@email.fr" required class="ch-back-in-stock__input">',
      '    <button type="submit" class="ch-back-in-stock__btn">Préviens-moi</button>',
      '  </div>',
      '  <p class="ch-back-in-stock__alt">Ou <a href="mailto:helene@collectionh.fr?subject=' + subject + '&body=' + body + '">écris à Hélène</a> pour une alternative.</p>',
      '</form>'
    ].join('');
  }

  function rerenderStockBlock(html, sectionId) {
    if (!html || !sectionId) return;
    // The new variant HTML contains the entire section. Find ch-stock-delivery inside it
    // and inject into the current page.
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newStock = doc.querySelector('.ch-stock-delivery');
      var curStock = document.querySelector('.ch-stock-delivery');
      if (newStock && curStock && newStock.outerHTML !== curStock.outerHTML) {
        curStock.outerHTML = newStock.outerHTML;
      }
    } catch (e) { /* noop */ }
  }

  function onVariantUpdate(e) {
    var detail = e.detail || {};
    var variant = detail.resource;
    var data = detail.data || {};
    var available = variant ? !!variant.available : true;
    setAvailability(available, variant);
    // Re-render stock block using the section HTML provided by Horizon
    var html = data.html ? (data.html.documentElement ? data.html.documentElement.outerHTML : String(data.html)) : null;
    rerenderStockBlock(html, data.productId);
    endTransition();
  }

  var transitionPending = false;
  var pendingFallbackTimer = null;
  var origAtcText = null;
  var mutationObserver = null;
  function forceLoadingText() {
    var btn = getAtcButton();
    if (!btn || !transitionPending) return;
    if (btn.textContent.trim() !== 'Chargement…') {
      btn.innerHTML = '<span class="add-to-cart-text">Chargement…</span>';
    }
    if (!btn.hasAttribute('disabled')) btn.setAttribute('disabled', '');
  }
  function startTransition() {
    transitionPending = true;
    var root = findProductInfo();
    root.setAttribute('data-variant-transitioning', 'true');
    var btn = getAtcButton();
    if (btn) {
      btn.dataset.chOrigHtml = btn.dataset.chOrigHtml || btn.innerHTML;
      forceLoadingText();
      btn.setAttribute('aria-busy', 'true');
      // Observe Horizon's re-renders et ré-applique "Chargement…" si nécessaire,
      // empêchant le flash "Ajouter au panier" entre le clic et la résolution finale.
      if (mutationObserver) mutationObserver.disconnect();
      mutationObserver = new MutationObserver(forceLoadingText);
      mutationObserver.observe(btn, { childList: true, subtree: true, attributes: true, characterData: true });
    }
    // Sticky ATC pareil
    var stickyBtn = document.querySelector('.ch-sticky-atc [data-sticky-atc-submit], .ch-sticky-atc button');
    if (stickyBtn) {
      stickyBtn.dataset.chOrigText = stickyBtn.dataset.chOrigText || stickyBtn.textContent;
      stickyBtn.textContent = 'Chargement…';
      stickyBtn.setAttribute('disabled', '');
    }
    var holder = document.getElementById('ch-back-in-stock-holder');
    if (holder) holder.style.visibility = 'hidden';
    if (pendingFallbackTimer) clearTimeout(pendingFallbackTimer);
    pendingFallbackTimer = setTimeout(function () { endTransition(); }, 2500);
  }
  function endTransition() {
    transitionPending = false;
    if (pendingFallbackTimer) { clearTimeout(pendingFallbackTimer); pendingFallbackTimer = null; }
    if (mutationObserver) { mutationObserver.disconnect(); mutationObserver = null; }
    var root = findProductInfo();
    root.removeAttribute('data-variant-transitioning');
    var btn = getAtcButton();
    if (btn) {
      btn.removeAttribute('aria-busy');
      var available = root.getAttribute('data-variant-available') !== 'false';
      // Au lieu de restaurer le HTML original (qui peut afficher "Ajouter au
      // panier" alors que la variante est en fait épuisée), on applique le bon
      // texte final directement. Horizon synchronisera son innerHTML peu après
      // sans poser problème.
      if (available) {
        // Restaurer le HTML d'origine seulement si la variante est dispo
        if (btn.dataset.chOrigHtml) {
          btn.innerHTML = btn.dataset.chOrigHtml;
        }
        btn.removeAttribute('disabled');
      } else {
        btn.innerHTML = '<span class="add-to-cart-text">Épuisé</span>';
        btn.setAttribute('disabled', '');
      }
      delete btn.dataset.chOrigHtml;
    }
    var holder = document.getElementById('ch-back-in-stock-holder');
    if (holder) holder.style.visibility = '';
  }
  // Fast variant lookup via /products/{handle}.js — bypasses Horizon's slow
  // section-render AJAX (~1.5s) to apply availability state in ~50-100ms.
  var productVariantsCache = null;
  function getProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function loadProductVariants(cb) {
    if (productVariantsCache) { cb(productVariantsCache); return; }
    var handle = getProductHandle();
    if (!handle) { cb(null); return; }
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        productVariantsCache = d.variants || [];
        cb(productVariantsCache);
      })
      .catch(function () { cb(null); });
  }
  function getCurrentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"], product-form input[name="id"]');
    return input ? input.value : null;
  }
  function setCurrentVariantId(id) {
    if (!id) return;
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"], product-form input[name="id"], product-form-component input[name="id"]').forEach(function (input) {
      input.value = id;
      input.setAttribute('value', id);
    });
  }
  function applyClickedVariantInput(input) {
    if (!input || !input.dataset.variantId) return;
    var variant = {
      id: input.dataset.variantId,
      title: input.value || input.getAttribute('aria-label') || '',
      available: input.dataset.optionAvailable !== 'false'
    };
    setCurrentVariantId(variant.id);
    setAvailability(variant.available, variant);
    if (window.location.pathname.indexOf('/products/') !== -1) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }
  function applyAvailabilityImmediate() {
    // Wait a tick for Horizon to update the form's variant id input
    setTimeout(function () {
      loadProductVariants(function (variants) {
        if (!variants) return;
        var id = getCurrentVariantId();
        if (!id) return;
        var v = variants.find(function (x) { return String(x.id) === String(id); });
        if (!v) return;
        setAvailability(!!v.available, { id: v.id, title: v.title, available: v.available });
        endTransition();
      });
    }, 50);
  }
  function onVariantSelected() {
    startTransition();
    applyAvailabilityImmediate();
  }
  // Bloquer aussi tout clic ATC tant que transition pending — ceinture + bretelles
  document.addEventListener('click', function (e) {
    if (!transitionPending) return;
    var btn = e.target.closest('.product-form__submit, button[name="add"], .add-to-cart-button');
    if (btn) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('click', function (e) {
    var label = e.target.closest('variant-picker .variant-option__button-label');
    if (!label) return;
    var input = label.querySelector('input[data-variant-id]');
    if (!input) return;
    if (input.dataset.optionAvailable === 'false') {
      input.checked = true;
      input.dataset.currentChecked = 'true';
      applyClickedVariantInput(input);
    }
  }, true);
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('variant-picker input[data-variant-id]');
    if (!input) return;
    setTimeout(function () {
      applyClickedVariantInput(input);
    }, 0);
  }, true);

  function init() {
    document.addEventListener('variant:update', onVariantUpdate);
    document.addEventListener('variant:selected', onVariantSelected);
    // Initial state — if the first available variant is sold out, sync UI immediately
    var btn = getAtcButton();
    if (btn) {
      var isDisabled = btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true';
      if (isDisabled) {
        // We don't have the variant resource yet, fake it as unavailable
        setAvailability(false, null);
      }
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
